<template>
    <div id="app">

		<Navbar/>


		<!-- <div style="text-align:center;">
			<img src="./assets/logo.png" style="margin:0 auto;">
		</div> -->

		<transition name="fade" mode="out-in" appear>
			<router-view/>
		</transition>

		<Footer/>
    </div>
</template>

<script>

import Navbar from './Navbar';
import Footer from './Footer';
export default {
	components: {
		w_width: 0,
		Navbar,
		Footer
	},
	data () {
		return {
			msg: 'Welcome to Your Vue.js App'
		}
	},
	methods: {
		handleResize() {
			this.w_width = window.innerWidth;
		}
	},
	mounted(){
		console.log("app.vue!!!")
	},
	created() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	},
}
</script>

<style lang="sass">
@import "~styles/global.sass"



*
	//color: white !important
	letter-spacing: 1px
	font-family: 微軟正黑體 !important

html, body
	//background: #333


.custom-scroller
	height: 40vh
#app 
	color: black
h1, h2 
	font-weight: normal
h1
	font-size: 32px
	@media (max-width: 768px)
		font-size: 26px



ul 
	list-style-type: none
	padding: 0


li 
	//display: inline-block
	margin: 0 10px


.video-box-wrap
	margin: 0 auto
	max-width: 60%
	@media (max-width: 768px)
		max-width: 100%
		//padding-bottom: 56.25%
	.video-box 
		padding-bottom: 56.25%
		position: relative
		border: 5px solid black
		border-bottom: none
		iframe 
			background: black
			position: absolute
			display: block
			top: 50%
			left: 50%
			transform: translate(-50%, -50%)
			width: 100%
			height: 100%
	.video-text
		background: black
		padding: 15px 10px
		text-align: center
		color: white
		font-size: 18px
		letter-spacing: 1px
		@media (max-width: 576px)
			font-size: 14px


.bd-btn
	color: black
	border: 1px solid black
	border-radius: 5px
	padding: 15px 0
	transition: .3s
	display: block
	text-align: center
	width: 50%
	max-width: 400px
	margin: 0 auto
	cursor: pointer
	outline: none
	background: none
	@media (max-width: 576px)
		max-width: auto
		padding: 10px 0
		width: 100%
		//margin: 0 auto
	&:hover
		text-decoration: none
		background: $red
		color: white
		border: 1px solid transparent



.list-wrap
	//overflow: hidden
	//height: 40vh
	background: #fff
	border-radius: 15px
	padding: 0 30px
	padding-bottom: 80px
	box-shadow: 0 1px 10px rgba(black, 0.3)
	@media (max-width: 576px)
		padding: 0 15px

	.custom-scroller .mCSB_container, .product-title
		margin: 0 50px!important
		@media (max-width: 768px)
			margin: 0 !important

.custom-scroller, .custom-scroller-wrap 
	@media (max-width: 768px)
		height: auto !important




.list-wrap
	.slick-track
		display: flex
	.slider-wrap
		padding: 0 50px
	.brand-slider
		border-bottom: 1px solid black
		.slick-slide
			height: auto !important
			position: relative
		a
			outline: none
			text-decoration: none
			&:before
				content: ""
				width: 100%
				height: 100%
				position: absolute
				top: 50%
				left: 50%
				-webkit-transform: translate(-50%, -50%)
				-ms-transform: translate(-50%, -50%)
				transform: translate(-50%, -50%)
				z-index: -1
			&:hover:before
				-webkit-transition: .3s
				-o-transition: .3s
				transition: .3s
				background: #ebebeb
		.brand-wrap
			padding: 20px 15px
			height: 100%
			img
				width: 100%
			.name
				text-align: center
				color: black
		.slick-arrow
			width: 23px
			fill: #999
			-webkit-filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))
			filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))
			.st0
				-webkit-transition: .3s
				-o-transition: .3s
				transition: .3s
			&:hover .st0
				fill: #b30000
		.name
			margin-top: 10px
	.bottom-list-wrap
		.main-title
			text-align: center
			padding: 30px 0
			padding-bottom: 15px
			h1
				//font-size: 28px
				font-weight: 400
				line-height: 35px
				display: inline-block
			.duration
				color: #777
				font-weight: 400
		.product-list ul
			margin: 0
			padding: 0
			li
				list-style: none
				display: -webkit-box
				display: -ms-flexbox
				display: flex
				padding: 10px 20px
				span
					display: block
					letter-spacing: 2px
				.p-name
					-webkit-box-flex: 3
					-ms-flex: 3
					flex: 3
				.p-code
					-webkit-box-flex: 1
					-ms-flex: 1
					flex: 1
					word-break: break-all
			.product-title
				font-size: 18px
				font-weight: 400
				border-bottom: 2px solid black
				margin: 0 50px
			.product
				color: #bbb
				padding: 10px 20px
				border-bottom: 1px solid #bbb
				font-weight: 300
				-webkit-transition: .3s
				-o-transition: .3s
				transition: .3s
				&:hover
					background: #ebebeb
					span
						color: black

@media (max-width: 991px)
	section#flower_list .slider-wrap
		padding: 0 30px

@media (max-width: 768px)
	section#flower_list .slider-wrap
		padding: 0 0px

@media (max-width: 576px)
	section#flower_list .bottom-list-wrap .product-list ul li
		padding: 10px 0px !important

@media (max-width: 991px)
	section#flower_list .bottom-list-wrap .product-list ul li .p-name
		-webkit-box-flex: 2
		-ms-flex: 2
		flex: 2

@media (max-width: 768px)
	section#flower_list .bottom-list-wrap .product-list ul li .p-name
		-webkit-box-flex: 1
		-ms-flex: 1
		flex: 1

@media (max-width: 768px)
	section#flower_list .bottom-list-wrap .product-list ul li .p-code
		padding-left: 15px
		letter-spacing: 0px

@media (max-width: 576px)
	section#flower_list .bottom-list-wrap .product-list ul .product-title
		margin: 0 10px

@media (max-width: 576px)
	section#flower_list .bottom-list-wrap .product-list ul .product-title span
		font-size: 16px
		color: #777

@media (max-width: 576px)
	section#flower_list .bottom-list-wrap .product-list ul .product span
		font-size: 16px
		color: #000



.custom-scroller .mCSB_draggerRail 
    background: #333 !important
    background-image: none
    opacity: 1
    width: 2px !important
    pointer-events: none
.custom-scroller .mCSB_dragger_bar
    background-color: #333 !important
    opacity: 1
.custom-scroller .mCSB_scrollTools
    top: 10px !important

.fade-enter-active, .fade-leave-active 
	transition: opacity 0.3s

.fade-enter, .fade-leave-active 
	opacity: 0
		




	

</style>



// WEBPACK FOOTER //
// src/App.vue